import type { AppRouteModule } from '/@/router/types';

import { t } from '/@/hooks/web/useI18n';
import { LAYOUT } from '/@/router/constant';

/**
 * 'bulk-tender': '大宗招标',
 */
const route: AppRouteModule = {
  path: '/bulk-tender',
  name: 'BulkTender',
  component: LAYOUT,
  redirect: '/bulk-tender/distribution-basic-info',
  meta: {
    icon: 'ic:sharp-my-location',
    title: t('routes.bulk-tender.main'),
    orderNo: 20000,
    roles: [20225036],
  },
  children: [
    /**
     * 'distribution-basic-info': '配送地基础信息维护',
     */
    {
      path: 'distribution-basic-info',
      name: 'DistributionBasicInfo',
      component: () => import('/@/views/bulk-tender/distribution-basic-info/index.vue'),
      meta: {
        title: t('routes.bulk-tender.distribution-basic-info'),
        roles: [20225037],
      },
    },
    /**
     * 'rate-info': '运价信息维护',
     */
    {
      path: 'rate-info',
      name: 'RateInfo',
      component: () => import('/@/views/bulk-tender/rate-info/index.vue'),
      meta: {
        title: t('routes.bulk-tender.rate-info'),
        roles: [20225042],
      },
    },
    /**
     * 'ex-factory-price-info': '出厂价信息维护',
     */
    {
      path: 'ex-factory-price-info',
      name: 'ExFactoryPriceInfo',
      component: () => import('/@/views/bulk-tender/ex-factory-price-info/index.vue'),
      meta: {
        title: t('routes.bulk-tender.ex-factory-price-info'),
        roles: [20225045],
      },
    },
    /**
     * 'quotation-information-confirm': '报价信息确认',
     */
    {
      path: 'quotation-information-confirm',
      name: 'QuotationInformationConfirm',
      component: () => import('/@/views/bulk-tender/quotation-information-confirm/index.vue'),
      meta: {
        title: t('routes.bulk-tender.quotation-information-confirm'),
        roles: [20225048],
      },
    },
    /**
     * 'quote-price-for-a-batch-of-vehicles': '拼车跟标报价',
     */
    {
      path: 'quote-price-for-a-batch-of-vehicles',
      name: 'QuotePriceForABatchOfVehicles',
      component: () => import('/@/views/bulk-tender/quote-price-for-a-batch-of-vehicles/index.vue'),
      meta: {
        title: t('routes.bulk-tender.quote-price-for-a-batch-of-vehicles'),
        roles: [20225049],
      },
    },
    /**
     * 'supplier-warehouse': '发货仓库管理',
     */
    {
      path: 'supplier-warehouse',
      name: 'SupplierWarehouse',
      component: () => import('/@/views/bulk-tender/supplier-warehouse/index.vue'),
      meta: {
        title: t('routes.bulk-tender.supplier-warehouse'),
        roles: [20225398],
      },
    },
    /**
     * 'delivery-base-management': '送达基地管理',
     */
    {
      path: 'delivery-base-management',
      name: 'DeliveryBaseManagement',
      component: () => import('/@/views/bulk-tender/delivery-base-management/index.vue'),
      meta: {
        title: t('routes.bulk-tender.delivery-base-management'),
        roles: [20225399],
      },
    },
  ],
};

export default route;
